import { monthlyTradesReportComponents } from "./monthlyTrades/navigationComponents";
import { dailySecurityReportComponents } from "./securityDaily/navigationComponents";
import { annualSecurityReportComponents } from "./securityAnnual/navigationComponents";
import { quarterlySecurityReportComponents } from "./securityQuarterly/navigationComponents";

export const securityCommissionComponents = [...monthlyTradesReportComponents, ...dailySecurityReportComponents,...quarterlySecurityReportComponents, ...annualSecurityReportComponents];
